import { useSyncExternalStore } from "react";
import { gameBus } from "../core/gameBus";

export type { MissionView } from "../core/gameBus";

export function useGameUi() {
  return useSyncExternalStore(
    gameBus.subscribe,
    gameBus.getSnapshot,
    gameBus.getSnapshot,
  );
}
